module.exports = __webpack_public_path__ + "static/media/mod-sonder.c908ffe3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/mod-sonder.jpg
// module id = 339
// module chunks = 0